import React from 'react';
import styles from './Form.module.css';
import GitHubButton from 'react-github-btn';


const Form = ({ showControls, showWidth, imageHeight, divisorBorder, handleInputChange, handleValueChange, before, after, imageStats, image_status }) => {

    function getColor(key, value) {

        if (key.includes('loaded')) {

            if (value === true) { return 'linear-gradient(106deg, rgba(67,212,115,1) 0%, rgba(0,177,184,1) 100%)' }
            else {

                return 'red'
            }


        } else if (key.includes('error')) {

            if (value === true) { return "red" }
            else {

                return 'linear-gradient(106deg, rgba(67,212,115,1) 0%, rgba(0,177,184,1) 100%)'
            }

        }

        return "black"

    }

    let image_stats = [];
    let count = 0;


    for (let [key, value] of Object.entries(imageStats)) {
        image_stats.push({ title: `${key}: ${value}`, count: count++, color: getColor(key, value) });
    };

    let onError_array = image_stats.map(x => <div key={x.count} style={{ padding: "15px", margin: "5px", background: x.color, borderRadius: '10px', fontWeight: 'bold' }}>{x.title}</div>);


    return (


        <div className={styles.form_Container}>
            <div className={styles.container}>

                <h2>React Before and After Slider                 <span role="img" aria-label="vamp" style={{ fontSize: "30px" }}>&#129499;</span>

                </h2>

                <div className={styles.github_info}>

                    <span style={{ margin: "5px" }}>
                        <GitHubButton href="https://github.com/ammarhalees" data-color-scheme="no-preference: light; light: light; dark: dark;" data-size="large" aria-label="Follow @ammarhalees on GitHub">Follow @ammarhalees</GitHubButton></span>
                    <span style={{ margin: "5px" }}>
                        <GitHubButton href="https://github.com/AmmarHalees/react-bna" data-color-scheme="no-preference: dark; light: light; dark: dark;" data-icon="octicon-star" data-size="large" aria-label="Star AmmarHalees/react-bna on GitHub">Star</GitHubButton></span>

                    <div style={{ padding: "10px" ,border:"1px solid rgba(255, 255, 255, 0.275)" }}  > <a rel="noopener noreferrer" target="_blank" style={{ color: "white", border: "none", textDecoration: "none" }} href="https://ammarhalees.github.io/work/">ammarhalees.com</a> </div>


                </div>


            </div>


            <div className={styles.container}>

                <h3 style={{ padding: "l0px" }}>Props</h3>

                <form style={{ textAlign: "left" }}>

                    <div className={styles.input_label}>

                        <label

                            style={{

                                width: "100%",
                                display: "grid",
                                gridTemplateColumns: "1fr 20px"
                            }}

                        >
                            showControls (Boolean):
                  <input
                                name="showControls"
                                type="checkbox"
                                checked={showControls}
                                onChange={handleInputChange}

                            />


                        </label>

                    </div>

                    <div className={styles.input_label}>

                        <label



                            style={{

                                width: "100%",
                                display: "grid",
                                gridTemplateColumns: "1fr 20px"
                            }}
                        >
                            showWidth  (Boolean):
                    <input
                                name="showWidth"
                                type="checkbox"
                                checked={showWidth}
                                onChange={handleInputChange}

                            />


                        </label>
                    </div>

                    <div className={styles.input_label}>

                        <label

                            style={{

                                width: "100%",
                                display: "grid",
                                gridTemplateColumns: "1fr 20px",
                            }}

                        >
                            divisorBorder  (Boolean):
                    <input
                                name="divisorBorder"
                                type="checkbox"
                                checked={divisorBorder}
                                onChange={handleInputChange} />
                        </label>
                    </div>

                    <div className={styles.input_label}>

                        <label>
                            imageHeight (Num)  ({imageHeight})vh:
                    <input
                                name="imageHeight"
                                type="range"
                                value={imageHeight}
                                onChange={handleValueChange}

                                max="80"
                                min="20"
                                className={styles.input}
                            />
                        </label>

                    </div>

                    <div>

                        <label>
                            before (URL or Data URI)  :
                         <input
                                name="before"
                                type="text"
                                value={before}
                                onChange={handleValueChange}
                                style={{ margin: "15px", padding: "5px", marginLeft: "0px", paddingLeft: "0px", width: "100%", background: "transparent", color: "white", border: "1px solid rgba(255, 255, 255, 0.274)" }}

                            />
                        </label>

                    </div>

                    <div>

                        <label>
                            after (URL or Data URI)  :
                         <input
                                name="after"
                                type="text"
                                value={after}
                                onChange={handleValueChange}
                                style={{ margin: "15px", padding: "5px", marginLeft: "0px", paddingLeft: "0px", width: "100%", background: "transparent", color: "white", border: "1px solid rgba(255, 255, 255, 0.274)" }}

                            />
                        </label>

                    </div>

                </form>

            </div>

            <div className={styles.container}>

                <h2>Methods     </h2>

                <div style={{ textAlign: "left" }}>

                    <h3>onError , onLoaded</h3>

                    {onError_array}

                </div>


            </div>





        </div >

    );
}

export default Form;